
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";
import { useTheme } from "@/hooks/useTheme";

import { Converter } from "@/containers/Converter";
import { Head } from "@/components/Head";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ConvertEverythingSection } from "@/sections/ConvertEverythingSection";
import { PricingSection } from "@/sections/PricingSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { FaqSection } from "@/sections/FaqSection";
import { BlogSection } from "@/sections/BlogSection";
import { CTASection } from "@/sections/CTASection";

const XdToFigma = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/XDToFigma"
        ogImage="/images/xd2figma-og-image.jpg"
      />

      <MagicianSection
        title={t("page/XDToFigma:title")}
        subtitle={t("page/XDToFigma:subtitle")}
        magicianLogoFile="figma"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ConvertEverythingSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ConvertEverythingSection
        images={[
          {
            src: "/svgs/convert-everything/symbols-components-xd-to-figma.svg",
            alt: "symbols/components",
          },
          {
            src:
              "/svgs/convert-everything/prototyping-transitions-xd-to-figma.svg",
            alt: "Prototyping for XD to Figma",
          },
          {
            src: "/svgs/convert-everything/text-and-colors-figma.svg",
            alt: "text-and-colors",
          },
        ]}
      />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/XDToFigma:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/xd-to-figma-converter-example.png",
          alt: "Xd to Figma converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/XDToFigma:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/XDToFigma:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/xd-to-figma-converted-file-elements.png",
          alt: t("page/XDToFigma:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/XDToFigma:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/XDToFigma:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/XDToFigma:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/XDToFigma:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/XDToFigma:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "IMAGE-RED-ICON",
            title: t(
              "page/XDToFigma:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/XDToFigma:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <PricingSection />
      <FaqSection />
      <BlogSection />

      <SelectFormatSection title={t("section/selectFormat:title")} />
      <CTASection
        title={t("section/cta:titles.xdToFigmaPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default XdToFigma;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/xd-to-figma',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  